import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
// components
import ModalRegister from "../../../../../../components/modal/ModalRegister/ModalRegister";
// utils
import { api } from "../../../../../../utils/api";
import { id } from "date-fns/locale";

const ModalRegisterClient = ({ onHide, visible, setNewClient }) => {
  const modalRef = useRef();
  const [file, setFile] = useState(null);
  const [bond, setBond] = useState(null);
  const [access, setAccess] = useState(null);
  const [spouse, setSpouse] = useState(null);
  const [address, setAddress] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [telephones, setTelephones] = useState([]);
  const [personalData, setPersonalData] = useState(null);
  const [showInputCrc, setShowInputCrc] = useState(false);
  const [typeRegister, setTypeRegister] = useState("fisica");
  const [showInputCreci, setShowInputCreci] = useState(false);

  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [errorsVisible, setErrorsVisible] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    const notification = toast.loading("Salvando dados...");

    try {
      const response = await api.post("register-general", data);

      if (response.data) {
        toast.update(notification, {
          render: response.data.success,
          autoClose: 1500,
          type: "success",
          isLoading: false,
        });
        setNewClient(
          {
            id: response.data.data.id,
            ...data,
          }
        );
      }
      onHide();
      setAccess(null);
      setFile(null);
      setBond(null);
      setSpouse(null);
      setAddress(null);
      setContacts([]);
      setDocuments([]);
      setTelephones([]);
      setPersonalData(null);
      setTypeRegister("fisica");
      setErrors(null);
      setLoading(false);
    } catch (e) {
      setErrors(e.response?.data?.errors);
      setErrorsVisible(true);
      toast.update(notification, {
        render: "Falha ao salvar informações!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ModalRegister
        file={file}
        bond={bond}
        ref={modalRef}
        baseData={{
          pivot: "CRM",
        }}
        access={access}
        onHide={() => {
          onHide();
          setAccess(null);
          setFile(null);
          setBond(null);
          setSpouse(null);
          setAddress(null);
          setContacts([]);
          setDocuments([]);
          setTelephones([]);
          setPersonalData(null);
          setTypeRegister("fisica");
          setErrors(null);
          setLoading(false);
        }}
        spouse={spouse}
        errors={errors}
        setFile={setFile}
        address={address}
        setBond={setBond}
        loading={loading}
        visible={visible}
        contacts={contacts}
        setAccess={setAccess}
        documents={documents}
        setSpouse={setSpouse}
        setAddress={setAddress}
        telephones={telephones}
        setContacts={setContacts}
        loadingModal={loadingModal}
        personalData={personalData}
        setDocuments={setDocuments}
        typeRegister={typeRegister}
        handleSubmit={handleSubmit}
        showInputCrc={showInputCrc}
        setTelephones={setTelephones}
        errorsVisible={errorsVisible}
        showInputCreci={showInputCreci}
        setShowInputCrc={setShowInputCrc}
        setTypeRegister={setTypeRegister}
        setPersonalData={setPersonalData}
        setErrorsVisible={setErrorsVisible}
        setShowInputCreci={setShowInputCreci}
      />
    </>
  );
};

export default ModalRegisterClient;
